import React from "react";
import { motion } from "framer-motion";
import "./HeroSection.scss";
import heroImg from "../../assets/profile_pic.jpg";

function HeroSection() {
  return (
    <>
      <div className="hero-section">
        <div className="hero-container">
          <motion.div
            whileInView={{ x: [-20, 0], opacity: [0, 1] }}
            transition={{ duration: 0.3 }}
            className="hero-left"
          >
            <div className="hero_text">
              <h1 className="title">Hi, I am Chukwuemeka Nkwo</h1>
              <h5 className="sub_title">I am a Software Engineer</h5>
            </div>
            <div className="hero_button">
              <a href="#about">
                <button className="read_more">Read More</button>
              </a>
              <a
                href="https://drive.google.com/file/d/1V0vD3tdChlEMBFWeKU45zW4f3OJdsLf8/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button className="download">Download CV</button>
              </a>
            </div>
          </motion.div>
          <motion.div
            whileInView={{ x: [20, 0], opacity: [0, 1] }}
            transition={{ duration: 0.5 }}
            className="hero-right"
          >
            <img src={heroImg} alt="dev_image" className="dev_image" />
          </motion.div>
        </div>
      </div>
    </>
  );
}

export default HeroSection;
